import { DataResult, State, process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn,
  GridNoRecords,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { IMilkModel } from "./milk-model";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { API_END_POINT } from "../../constants";
import HomePageModel from "../../models/transaction/homepage-model";
import { RefreshIcon } from "../../assets/images/refresh-icon";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import dayjs from "dayjs";

interface IDashboardProps {
  type: string;
  pOrderDate?: Date;
}

const FermentedMilk: React.FunctionComponent<IDashboardProps> = ({
  ...props
}) => {
  const [orderDate, setOrderDate] = useState<string>("");
  const [homePageFermentedDetail, setHomepagefermenteddetail] = useState<
    HomePageModel[]
  >([]);

  const initialDataState: State = {
    take: 50,
    skip: 0,
  };
  const [dataStateArray, setDataStateArray] = useState<State>(initialDataState);
  const [gridData, setGridData] = useState<DataResult>({ data: [], total: 0 });
  const [resultData, setResultData] = useState<DataResult>();
  //const { isLoading, isError, refetch: reload, data: result } = useInspectors({ variables: { claimID: claimInfo?.claimID } })
  const [result, setResult] = useState<any[]>([]);
  const [isLoadingFermented, setIsLoadingFermented] = useState(false);

  useEffect(() => {
    // const today = new Date();
    // const day = today.getDate().toString().padStart(2, "0");
    // // const month = today.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
    // const month = (today.getMonth() + 1).toString().padStart(2, "0");
    // const year = today.getFullYear();
    // const formattedDate = `${year}-${month}-${day}`;

    const formattedDate = dayjs(props?.pOrderDate).format("YYYY-MM-DD");
    setOrderDate(formattedDate);

    fetchMilkData(formattedDate);
  }, [props?.pOrderDate]);

  const fetchMilkData = async (orderDate: string) => {
    const url =
      getEndPoint(API_END_POINT.ORDER) +
      `/api/HomePage/GetHomePageMilkDetails/${orderDate}/2`;

    console.log("Fetching fermented milk data from:", url);

    try {
      setIsLoadingFermented(true);
      const response = await getDataWithToken<any>(url);
      const detailList = response?.data?.result || [];
      setHomepagefermenteddetail(detailList);
    } catch (error) {
      console.error("Error fetching fermented milk data:", error);
    } finally {
      setIsLoadingFermented(false);
    }
  };

  const handleDataStateChange = (e: GridPageChangeEvent) => {
    const newDataState = { skip: e.page.skip, take: e.page.take };
    setDataStateArray(newDataState);
  };

  return (
    <>
      <div className="card p-3 border-0 sw-shadow radius-15">
        <div className="d-flex mb-2">
          <h4>{props?.type}</h4>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Reload the grid</Tooltip>}
            placement="bottom-start"
          >
            <div
              className="d-flex ms-auto refresh-container"
              onClick={() => fetchMilkData(orderDate)}
            >
              <RefreshIcon></RefreshIcon>
            </div>
          </OverlayTrigger>
        </div>
        {isLoadingFermented ? (
          <LoadingIndicator
            isLoading={isLoadingFermented}
            title="reloading.."
          /> // your spinner component or loading text
        ) : (
          <Grid
            style={{ height: "400px" }}
            data={homePageFermentedDetail}
            pageable={{ pageSizes: [50, 100, 200, 500] }}
            skip={dataStateArray.skip}
            take={dataStateArray.take}
            total={gridData.total}
            sortable={true}
            groupable={false}
            {...dataStateArray}
            onPageChange={(e) => handleDataStateChange(e)}
            columnVirtualization={false}
            resizable={true}
          >
            <GridColumn field="product" title="Product" filter={"text"} />
            <GridColumn field="morningQty" title="Morning" filter={"text"} />
            <GridColumn field="eveningQty" filter={"text"} title="Evening" />
            <GridColumn field="totalQty" filter={"text"} title="Total" />
            <GridColumn field={"amount"} filter={"text"} title="Amount" />
            <GridNoRecords>
              <div style={{ width: "100%", height: "500px" }}>
                <center>No data found</center>
              </div>
            </GridNoRecords>
          </Grid>
        )}
      </div>
    </>
  );
};
export default FermentedMilk;
function setSelectedValue(data: any[]): any {
  throw new Error("Function not implemented.");
}
